import { EmptyState } from "@design-system/EmptyState/EmptyState";

/** What the task list shows with no tasks: a way back out when filters emptied it. */
export const TaskListEmptyState = ({
    hasActiveFilters,
    onClearFilters,
}: {
    hasActiveFilters: boolean;
    onClearFilters: () => void;
}) =>
    hasActiveFilters ? (
        <EmptyState
            header="No tasks match these filters"
            action={onClearFilters}
        />
    ) : (
        <EmptyState header="No tasks yet" />
    );
